import { useContext, createContext, ReactNode, useState } from 'react';

interface DialogParams {
  isOpen: boolean;
  id?: string;
}
interface DialogContextParams {
  isOpen: DialogParams;
  setIsOpen(params: DialogParams): unknown;
}

const DialogContext = createContext<DialogContextParams | undefined>(undefined);

export const useContractLimitDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('Dialog must be used within a DialogProvider');
  }
  return context;
};

export const ContractLimitDialogProvider = (props: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState<DialogParams>({ isOpen: false });

  return <DialogContext.Provider value={{ isOpen, setIsOpen }}>{props.children}</DialogContext.Provider>;
};
